import { useDispatch, useSelector } from 'react-redux';
import { useState, useCallback, useMemo } from 'react';
import httpInjectorService from 'services/http-injector.service';
import { setProjectName } from 'store/actions';
import {
  setsprintdata,
  setassigneelist,
  setbacklogdata,
  setEpiclist,
  setlabellist,
} from 'store/actions';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';
import dayjs from 'dayjs';
import { message } from 'antd';
import Cookies from 'js-cookie';

export const useFetchBacklogData = () => {
  //const [labelOptions, setLabelOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  // const [tasks, set] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [sprints, setSprints] = useState([]);
  const [backlogData, setBacklogData] = useState([]);

  //  const [originalSprints, setOriginalSprints] = useState([]);
  //const [originalBacklog, setOriginalBacklog] = useState([]);

  // filtered copies (for when filters applied)
  const [filteredSprints, setFilteredSprints] = useState([]);
  const [filteredBacklog, setFilteredBacklog] = useState([]);
  const [isFiltering, setIsFiltering] = useState(false);

  const dispatch = useDispatch();
  const { id } = useParams();
  const projectId = Number(id);

  const assigneeOptions = useSelector(
    (state) => state.Authentication?.assigneelist,
  );
  const epicOptions = useSelector((state) => state.Authentication?.Epiclist);

  const labelOptions = useSelector((state) => state.Authentication?.labellist);

  const projectName = Cookies.get('project_name');
  //console.log('projectname fron redux', projectName);

  // const sprints = useSelector((state) => state.Authentication.sprintdata);
  //console.log('sprints data', sprints);

  //const backlogData = useSelector((state) => state.Authentication.backlogdata);
  //console.log('backlog data', backlogData);
  const getStatusCounts = useCallback((tasks = []) => {
    return tasks.reduce((acc, task) => {
      const status = task.task_status || task.status;
      if (!status) return acc;

      acc[status] = (acc[status] || 0) + 1;
      return acc;
    }, {});
  }, []);

  const backlogCounts = useMemo(() => {
    return {
      total: backlogData.length,
      byStatus: getStatusCounts(backlogData),
    };
  }, [backlogData]);

  const sprintCounts = useMemo(() => {
    return sprints.map((sprint) => {
      const tasks = sprint.tasks || [];
      return {
        sprint_id: sprint.sprint_id,
        sprint_name: sprint.name,
        total: tasks.length,
        byStatus: getStatusCounts(tasks),
      };
    });
  }, [sprints, getStatusCounts]);

  const fetchBacklogData = useCallback(async () => {
    if (loading) return;
    try {
      const response = await httpInjectorService.getSprintBacklogData({
        project_id: projectId,
      });
      if (response.status === 'success') {
        const assigneeMap = {};
        assigneeOptions.forEach((user) => {
          assigneeMap[user.user_id] = user;
        });
        const epicMap = {};
        epicOptions.forEach((epic) => {
          epicMap[epic.epic_id] = epic;
        });
        const projectName = response.data.project_name;
        await dispatch(setProjectName(projectName));
        // console.log({ projectName });
        Cookies.set('project_name', projectName, {
          expires: 7,
        });
        const mappedSprints = (response.data?.sprints || []).map((sprint) => ({
          sprint_id: sprint.sprint_id,
          id: sprint.sprint_id,
          name: sprint.sprint_name,
          status: sprint.status,
          start_date: sprint.start_date ? dayjs(sprint.start_date) : null,
          end_date: sprint.end_date ? dayjs(sprint.end_date) : null,
          sprint_goal: sprint.sprint_goal || '',
          days_left: sprint.days_left ?? null,
          collapsed: false,
          tasks: (sprint.tasks || []).map((task) => ({
            issue_type_id: task.issue_type_id,
            issue_type: task.issue_type,
            id: task.issue_id,
            key: task.issue_key,
            title: task.issue_title || 'Task',
            type: task.issue_type,
            task_status: task.issue_status,
            status: task.issue_status?.trim() || '+ status',

            subtasks_count: {
              total: task.subtasks_count?.total ?? 0,
              done: task.subtasks_count?.done ?? 0,
            },
            epic: task.epic_id
              ? {
                  epic_id: task.epic_id,
                  epic_name:
                    epicMap[task.epic_id]?.epic_name ||
                    task.epic_name ||
                    '+ epic',
                }
              : task.epic_name
                ? { epic_id: null, epic_name: task.epic_name }
                : { epic_id: null, epic_name: '+ epic' },
            epic_id: task.epic_id,

            description: task.description || '',
            story_points: task.story_points ?? 0,
            labels:
              typeof task.labels === 'string'
                ? task.labels
                    .split(',')
                    .map((labelName) => {
                      const found = labelOptions.find(
                        (l) =>
                          l.label_name.toLowerCase() ===
                          labelName.trim().toLowerCase(),
                      );
                      return found || null;
                    })
                    .filter(Boolean)
                : Array.isArray(task.labels)
                  ? task.labels
                  : [],

            assignee_id: task.assignee_id,
            assignee: assigneeMap[task.assignee_id]
              ? {
                  id: task.assignee_id,
                  username: assigneeMap[task.assignee_id].username,
                }
              : null,
            dueDate: task.due_date
              ? dayjs(task.due_date).format('YYYY-MM-DD')
              : null,
          })),
        }));
        const mappedBacklog = (response.data?.backlog || []).map((task) => ({
          issue_type_id: task.issue_type_id,
          issue_type: task.issue_type,
          issue_id: task.issue_id,
          issue_key: task.issue_key,
          issue_title: task.issue_title || 'Untitled Task',
          issue_status: task.issue_status?.trim() || '+status',
          type: task.issue_type,
          subtasks_count: {
            total: task.subtasks_count?.total ?? 0,
            done: task.subtasks_count?.done ?? 0,
          },
          epic: task.epic_id
            ? {
                epic_id: task.epic_id,
                epic_name:
                  epicMap[task.epic_id]?.epic_name ||
                  task.epic_name ||
                  '+ epic',
              }
            : task.epic_name
              ? { epic_id: null, epic_name: task.epic_name }
              : { epic_id: null, epic_name: '+ epic' },
          epic_id: task.epic_id,
          description: task.description || '',
          story_points: task.story_points ?? 0,
          labels:
            typeof task.labels === 'string'
              ? task.labels
                  .split(',')
                  .map((labelName) => {
                    const found = labelOptions.find(
                      (l) =>
                        l.label_name.toLowerCase() ===
                        labelName.trim().toLowerCase(),
                    );
                    return found || null;
                  })
                  .filter(Boolean)
              : Array.isArray(task.labels)
                ? task.labels
                : [],

          assignee_id: task.assignee_id,
          assignee: assigneeMap[task.assignee_id]
            ? {
                id: task.assignee_id,
                username: assigneeMap[task.assignee_id].username,
              }
            : null,
          dueDate: task.due_date
            ? dayjs(task.due_date).format('YYYY-MM-DD')
            : null,
        }));
        //console.log(mappedBacklog, 'backlog data');

        //setSprints(mappedSprints);
        // store originals
        //setOriginalSprints(mappedSprints);
        // setOriginalBacklog(mappedBacklog);

        // reset filters
        setFilteredSprints([]);
        setFilteredBacklog([]);

        setSprints(mappedSprints);
        setBacklogData(mappedBacklog);

        dispatch(setsprintdata(mappedSprints));
        dispatch(setbacklogdata(mappedBacklog));
      } else {
        toast.error('Failed to load backlog data');
        setBacklogData([]);
        setSprints([]);
        //dispatch(setsprintdata([]));
        //dispatch(setbacklogdata([]));

        //setLoading(false)
      }
    } catch (error) {
      console.error('Error in fetchBacklogData:', error);
      toast.error('Error fetching backlog data');
      setBacklogData([]);
      setSprints([]);
      //dispatch(setsprintdata([]));
      //dispatch(setbacklogdata([]));

      // setLoading(false)
    } finally {
      setLoading(false);
    }
  }, [
    projectId,
    assigneeOptions,
    epicOptions,
    labelOptions,
    dispatch,
    loading,
    // sprints,
    // backlogData,
  ]);

  const addSprint = useCallback((newSprint) => {
    setSprints((prev) => [...prev, newSprint]);
  }, []);

  const filterTask = useCallback(
    async (filters) => {
      setIsFiltering(true);

      try {
        const response = await httpInjectorService.filterBacklogTask({
          project_id: projectId,
          filters,
        });

        if (response.status === 'success') {
          const filteredTasks = response.data || [];

          if (filteredTasks.length === 0) {
            toast.error('No Task Found');
            return;
          }

          const allowed = new Set(filteredTasks.map((t) => Number(t.issue_id)));

          setFilteredBacklog(
            backlogData.filter((t) => allowed.has(Number(t.issue_id))),
          );

          setFilteredSprints(
            sprints.map((sp) => ({
              ...sp,
              tasks: sp.tasks.filter((t) => allowed.has(t.id)),
            })),
          );
        }
      } catch {
        message.error('Failed to filter');
      }
    },
    [backlogData, sprints],
  );

  const matchesSearch = (task) => {
    const term = searchTerm.toLowerCase().trim();
    if (!term) return true;

    const title = task.title || task.issue_title || task.task_title || '';

    const key = task.key || task.issue_key || '';

    return (
      title.toLowerCase().includes(term) || key.toLowerCase().includes(term)
    );
  };

  const transformedBacklog = Array.isArray(backlogData)
    ? backlogData.map((task) => ({
        issue_type_id: task.issue_type_id,
        issue_type: task.issue_type,
        id: task.issue_id,
        key: task.issue_key,
        title: task.issue_title,
        type: task.task_type,
        status: task.issue_status || '+status',
        epic_id: task.epic_id,
        epic: task.epic,
        story_points: task.story_points ?? 0,
        labels:
          typeof task.labels === 'string'
            ? task.labels
                .split(',')
                .map((labelName) => {
                  const found = labelOptions.find(
                    (l) =>
                      l.label_name.toLowerCase() ===
                      labelName.trim().toLowerCase(),
                  );
                  return found || null;
                })
                .filter(Boolean)
            : Array.isArray(task.labels)
              ? task.labels
              : [],
        assignee_id: task.assignee_id || null,
        assignee: task.assignee,
        dueDate: task.dueDate || '',
        subtasks_count: {
          total: task.subtasks_count?.total ?? 0,
          done: task.subtasks_count?.done ?? 0,
        },
      }))
    : [];

  const displayedBacklog = isFiltering
    ? filteredBacklog.filter(matchesSearch)
    : transformedBacklog.filter(matchesSearch);

  const baseSprints = isFiltering ? filteredSprints : sprints;

  const displayedSprints = baseSprints.map((sprint) => ({
    ...sprint,
    tasks: sprint.tasks.filter(matchesSearch),
  }));

  const updateTaskStoryPoints = (taskId, newPoints) => {
    setBacklogData((prev) =>
      prev.map((task) =>
        task.issue_id === taskId ? { ...task, story_points: newPoints } : task,
      ),
    );

    setSprints((prev) =>
      prev.map((sprint) => ({
        ...sprint,
        tasks: sprint.tasks.map((task) =>
          task.id === taskId ? { ...task, story_points: newPoints } : task,
        ),
      })),
    );
  };

  return {
    fetchBacklogData,
    loading,
    filterTask,
    displayedSprints,
    displayedBacklog,
    searchTerm,
    setSearchTerm,
    addSprint,
    sprints,
    backlogData,
    setBacklogData,
    setSprints,
    isFiltering,
    setIsFiltering,
    setFilteredBacklog,
    setFilteredSprints,
    updateTaskStoryPoints,
    backlogCounts,
    sprintCounts,
    transformedBacklog,
  };
};
